<template lang="pug">
.landing(style="margin-buttom: 50px;")
  #section-principal(v-if="sectionPrincipal")
    .section-principal-mobile
      figure
        figcaption
          h1 Registra y consulta tu siniestro
        img(src='../assets/img/siniestros-banner-mobile.png')
    .section-principal.only-desktop
      figure
        figcaption
          h1(style="font-weight: 400; font-size: 44px; line-height: 40px; text-align: center; color: #535D66;") Registra y consulta tu siniestro
        img(src='../assets/img/siniestros-banner.png')
    .container
      .section-content
        h2(style="font-weight: 400; text-align: center;")
          | Aquí podrás registrar y consultar el estado de tu  <strong style="font-weight: 700;">Siniestro</strong> de manera sencilla.
        section.menu
          .item-button.menu-principal
            article(@click="goToRegistro()")
              figure
                img(src="../assets/img/registrar-siniestro.png")
            h3 Registra tu siniestro
          .item-button.menu-principal
            article(@click="goToConsulta()")
              figure
                img(src="../assets/img/consultar-siniestro.png")
            h3 Estado de solicitud
        div(id="g-recaptcha" class="g-recaptcha" :data-sitekey="siteKey" style="margin: 30px auto; width: 300px;" v-if="sectionCaptcha")
    //- .container.only-desktop
      .section-content
        h3(style="font-weight: 400; text-align: center; font-size: 24px; line-height: 26px; margin-bottom: 50px;") Antes de continuar, &nbsp;
          strong verifica que tu correo electrónico y número de celular sean los correctos
          |.
          br
          | Toda comunicación respecto a tu caso será notificada por cualquiera de estos medios.
    //- section(style="background: #00ADEE;")
      .container.only-mobile
        v-flex.section-content(style="display: flex; flex-direction: row;")
          figure(style="width: 115px; height: 115px")
            img(src="../assets/img/character/informa.svg" style="width: 115px; height: 115px")
          h3(style="font-weight: 400; font-size: 16px; line-height: 16px; margin-bottom: 50px; color: #FFFFFF; padding-left: 20px;") Antes de continuar, &nbsp;
            strong verifica que tu correo electrónico y número de celular sean los correctos
            |.
            br
            br
            | Toda comunicación respecto a tu caso será notificada por cualquiera de estos medios.
    section(style="background: #F5F5F5;")
      .container
        section(style="display: flex; justify-content: row")
          v-flex.only-desktop-flex(xs12 sm12 md6 lg6)
            v-layout
              figure(style="margin: auto;")
                img(src="../assets/img/demo-smartphone.svg")
          v-flex.only-desktop-flex(xs12 sm12 md6 lg6)
            v-layout(style="display: flex; flex-direction: column;")
              h2(style="font-weight: 400; font-size: 36px !important;line-height: 39px; text-align: left; color: #0855C4; margin-top: 30px;") ¿Deseas saber como registrar un siniestro?
              p(style="padding-top: 20px; padding-bottom: 20px; text-align: left;") Aquí podrás descargar el manual de los pasos, con la información necesaria.
              v-btn.btn-solicitud.btn-pink-filled.omnesMedium(type='button' @click="downloadManual()" style="margin: 0; height: 50px; width: 220px;") Descargar manual
          v-flex.only-mobile-flex
            v-layout(style="display: flex; flex-direction: column; margin-bottom: 40px;")
              h2(style="font-weight: 400; font-size: 36px !important;line-height: 39px; text-align: center; color: #0855C4; margin-top: 30px;") ¿Deseas saber como registrar un siniestro?
              p(style="padding-top: 20px; padding-bottom: 20px; text-align: center;") Aquí podrás descargar el manual de los pasos, con la información necesaria.
              v-btn.btn-solicitud.btn-pink-filled.omnesMedium(type='button' @click="downloadManual()" style="margin: 0 auto; height: 50px; width: 220px;") Descargar manual
  .section-registro-siniestro(v-if="sectionRegistroSiniestro")
    .section-title.only-mobile
      h2 Nosotros nos haremos cargo cuando las cosas se pongan difíciles.
    .section-title.only-desktop(style="padding: 40px; padding-top: 60px; font-style: normal; font-weight: 600; font-size: 22px !important; line-height: 23px !important; align-items: center; text-align: center;")
      h2 Nosotros nos haremos cargo cuando las cosas se pongan difíciles.
  #section-menu(v-if="sectionMenu")
      .section-content
        h2(style="align-text: center;") Selecciona tu producto
        section.menu
          .item-button.menu-principal
            article(@click="goToCoberturas('Vida')")
              figure
                img(src="../assets/img/icono-seguro-de-vida.png")
            h3 Seguro de Vida
          .item-button.menu-principal
            article(@click="goToCoberturas('SOAT')")
              figure
                img(src="../assets/img/icono-soat.png")
            h3 SOAT
          .item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Protección tarjeta')")
              figure
                img(src="../assets/img/icono-proteccion-tarjeta.png")
            h3 Protección de tarjetas
          .item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Protección financiera')")
              figure
                img(src="../assets/img/icono-proteccion-financiera.png")
            h3 Protección financiera
        section.menu.only-desktop-flex
          .item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Desgravamen')")
              figure
                img(src="../assets/img/icono-desgravamen.png")
            h3 Desgravamen
          //-.item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Vehicular')")
              figure
                img(src="../assets/img/icono-vehicular.png")
            h3 Vehicular
          .item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Vida Ley')")
              figure
                img(src="../assets/img/icono-vida-ley.png")
            h3 Vida ley
          .item-button.menu-principal.only-desktop-flex
            article(@click="goToCoberturas('Renta Hospitalaria')")
              figure
                img(src="../assets/img/icono-renta-hospitalaria.png")
            h3 Renta Hospitalaria
          .item-button.menu-principal.only-desktop-flex(style="pointer-events: none")
        section.menu.only-mobile-flex
          .item-button.menu-principal
            article(@click="goToCoberturas('Protección tarjeta')")
              figure
                img(src="../assets/img/icono-proteccion-tarjeta.png")
            h3 Protección de tarjetas
          .item-button.menu-principal
            article(@click="goToCoberturas('Protección financiera')")
              figure
                img(src="../assets/img/icono-proteccion-financiera.png")
            h3 Protección financiera
        section.menu.only-mobile-flex
          .item-button.menu-principal
            article(@click="goToCoberturas('Desgravamen')")
              figure
                img(src="../assets/img/icono-desgravamen.png")
            h3 Desgravamen
          //- .item-button.menu-principal
          //-   article(@click="goToCoberturas('Vehicular')")
          //-     figure
          //-       img(src="../assets/img/icono-vehicular.png")
          //-   h3 Vehicular
          .item-button.menu-principal
            article(@click="goToCoberturas('Vida Ley')")
              figure
                img(src="../assets/img/icono-vida-ley.png")
            h3 Vida Ley
        section.menu.only-mobile-flex
          .item-button.menu-principal
            article(@click="goToCoberturas('Renta Hospitalaria')")
              figure
                img(src="../assets/img/icono-renta-hospitalaria.png")
            h3 Renta Hospitalaria
          .item-button.menu-principal(style="pointer-events: none")
  #section-submenu(v-if="sectionSubMenu")
    .section-content
      h2.only-desktop(v-html="form.tipoPoliza.toLowerCase() === 'soat' ? 'Seleccionar coberturas SOAT' : 'Selecciona cobertura del Seguro de Vida'")
      h2.only-mobile(v-html="form.tipoPoliza.toLowerCase() === 'soat' ? 'Selecciona coberturas SOAT' : 'Selecciona cobertura del <br> Seguro de Vida'")
      h3(v-if="form.tipoPoliza.toLowerCase() === 'soat'" style="text-align: center; color: #0855c4; font-weight: 400;") Puedes elegir más de una cobertura
      section.submenu
        .item-button(v-for="item of dataCoberturas" :key="item.key")
          v-tooltip.only-desktop(bottom style="z-index: 112 !important;")
            template(v-slot:activator='{ on, attrs }')
              article(@click="selectCobertura(item.key)" :style="item.selected?'background: #0855C4 !important; cursor: pointer;':'cursor: pointer;'" v-bind="attrs" v-on="(item.tooltip)?on:null")
                figure
                  img(:src="require(`../assets/img/${item.img}`)")
              h3(@click="selectCobertura(item.key)" style="cursor: pointer;" v-bind="attrs" v-on="(item.tooltip)?on:null") {{item.name}}
            span.tooltip-poput.only-desktop(v-if="item.tooltip" style="color:#FFF;" v-html="item.tooltip")
      v-layout(row wrap justify-center)
        v-btn.btn-solicitud.btn-pink-filled.omnesSemibold#btn-coverages(type='button' :disabled="coberturasSeleccionadas.length === 0" @click="goToDatos()" style="height: 50px;") Continuar
      v-layout(row wrap justify-center style="margin-top: 20px;")
        a.btn-volver(@click="goBackToRegistro()") Volver
  #section-solicitud(v-if="sectionSolicitud")
    v-flex.stepper(v-if="sectionStepper")
      v-stepper#main-stepper(alt-labels v-model="stepperPoint")
        v-layout(row wrap justify-center)
          v-flex(xs8 sm6 md4 lg3)
            v-stepper-header
              v-stepper-step(step="1" :complete="stepperPoint >= 1")
                | Solicitud
              v-divider
              v-stepper-step(step="2" :complete="stepperPoint >= 2")
                | Resumen
    v-layout(row wrap justify-center v-if="sectionDatos" style="margin-top: -20px;")
      .section-content
        h2.subtitle-content Completa la información
    br(v-if="sectionDatos")
    v-layout(row wrap justify-center style="margin-bottom: 40px;")
      v-flex.view_myproduct(xs0 sm0 md5 lg4 v-if="sectionDatos")
        v-layout
          v-flex.myproduct
            h2.omnesMedium.mp-title.only-desktop Datos
            .section-solicitud-datos(style="margin-bottom: 0px;")
              v-layout.row-mp-subtitle(:style="aseguradoComprimido ? {'border-bottom': '1px solid #E7EAED'} : {}")
                v-flex(lg9)
                  .row
                    h4.omnesRegular.mp-subtitle 1. Datos del {{form.tipoPoliza.toLowerCase() === 'soat' ? 'lesionado' : 'asegurado'}}
                    v-tooltip(bottom style="z-index: 112 !important;")
                      template(v-slot:activator='{ on, attrs }')
                        svg(style="height: 14px;align-self: center;margin-left: 5px;" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-bind="attrs" v-on="on")
                          path(d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                          path(d="M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z" fill="white")
                      span.tooltip-poput(style="color:#FFF;") El lesionado es aquella persona que sufre un accidente <br class="only-dektop"> o siniestro. También puede ser el solicitante.
                  .row
                    h5.omnesRegular.mp(v-if="form.asegurado.nombres && form.asegurado.apellidoPaterno && aseguradoComprimido" style="padding-left: 20px;")
                      | {{form.asegurado.nombres.split(' ')[0] + ' ' + form.asegurado.apellidoPaterno + ' '}}
                v-flex.col-mp-button(lg3 style="display: flex;align-items: center; justify-content: flex-end;")
                  span(@click="aseguradoComprimido = !aseguradoComprimido" :style="aseguradoComprimido ? {'font-weight': '500', 'margin-top': '-5px'} : {'font-weight': '700', 'margin-top': '-5px'}") Editar
                  svg(width="7" height="12" viewBox="0 0 8 16" fill="none" :class="(aseguradoComprimido)?'arrow-down':'arrow-up'" xmlns="http://www.w3.org/2000/svg" style="align-self: center;")
                    path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")
              .section-data-content(v-if="!aseguradoComprimido")
                v-layout.row-mp-data
                  v-text-field(label="Apellido Paterno", outline, v-model="form.asegurado.apellidoPaterno" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="Apellido Materno", outline, v-model="form.asegurado.apellidoMaterno" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="Nombres", outline, v-model="form.asegurado.nombres", browser-autocomplete="off" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="N° de documento DNI/CE", outline, v-model="form.asegurado.nroDocumento", browser-autocomplete="off" @keydown="(event) => onlyNumbers(event)")
            .section-solicitud-datos(v-if="sectionSolicitante")
              v-layout.row-mp-subtitle(:style="solicitanteComprimido ? {'border-bottom': '1px solid #E7EAED'} : {}")
                v-flex(lg9 style="display: flex; align-items: center; flex-direction: column; margin-left: -15px; margin-right: 15px;")
                  .row(style="width: 100%;")
                    h4.omnesRegular.mp-subtitle 2. Datos del solicitante
                  .row(style="width: 100%;")
                    h5.omnesRegular.mp(v-if="form.solicitante.nombres && form.solicitante.apellidoPaterno && solicitanteComprimido" style="padding-left: 20px;")
                      | {{form.solicitante.nombres.split(' ')[0] + ' ' + form.solicitante.apellidoPaterno}}
                v-flex.col-mp-button(lg3 style="display: flex;align-items: center; justify-content: flex-end;")
                  span(@click="solicitanteComprimido = !solicitanteComprimido" :style="solicitanteComprimido ? {'font-weight': '500', 'margin-top': '-5px'} : {'font-weight': '700', 'margin-top': '-5px'}") Editar
                  svg(width="7" height="12" viewBox="0 0 8 16" fill="none" :class="(solicitanteComprimido)?'arrow-down':'arrow-up'" xmlns="http://www.w3.org/2000/svg" style="align-self: center;")
                    path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")

              .section-data-content(v-if="!solicitanteComprimido")
                v-layout.row-mp-data(style="margin-top: -45px;" v-if="!(this.coberturasSeleccionadas.includes('Fallecimiento'))")
                  v-checkbox(v-model='selectedInsuredCopy' @change="copyInsured()")
                    template(v-slot:label='')
                      div.selected-insured-copy(:class="selectedInsuredCopy ? 'checked' : 'unchecked'")
                        | Marque la casilla si los datos del solicitante son los mismos que el {{form.tipoPoliza.toLowerCase() === 'soat' ? 'lesionado' : 'asegurado'}}.
                v-layout.row-mp-data
                  v-text-field(label="Apellido Paterno", outline, v-model="form.solicitante.apellidoPaterno" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="Apellido Materno", outline, v-model="form.solicitante.apellidoMaterno" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="Nombres", outline, v-model="form.solicitante.nombres", browser-autocomplete="off" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  v-text-field(label="N° de documento DNI/CE", outline, v-model="form.solicitante.nroDocumento", browser-autocomplete="off" @keydown="(event) => onlyNumbers(event)")
                //- v-layout.row-mp-data
                  v-text-field(label="Correo electrónico", outline, v-model="form.solicitante.correo", browser-autocomplete="off")
                v-layout.row-mp-data(style="display:flex; flex-direction: column;")
                  v-text-field(label="Correo electrónico" outline, v-model="form.solicitante.correo" browser-autocomplete="off" @blur="validateEmail" @keydown="() => revalidateEmail()")
                  p.error-message(v-show="showErrorMessage" style="color: red;margin: -25px 26px 25px 20px;font-size: 15px;text-align: justify;line-height: 16px;") Ingrese un correo electrónico válido. Ej: "micorreo@gmail.com"
                v-layout.row-mp-data
                  v-text-field(label="Celular", outline, v-model="form.solicitante.celular", browser-autocomplete="off" @keydown="(event) => onlyNumbers(event, 9)")
                v-layout.row-mp-data
                  svg(xmlns='http://www.w3.org/2000/svg', width='42', height='42', viewbox='0 0 42 42', fill='none', style="margin: 0px 0px 0px -15px;")
                    circle(cx='6.5', cy='6.5', r='6.5', fill='#454A6C')
                    path(d='M6.666 8.508C6.498 8.508 6.47 8.382 6.456 8.172L6.148 2.432C6.134 2.012 6.302 1.886 6.554 1.886H6.904C7.156 1.886 7.324 2.012 7.31 2.432L7.002 8.172C6.988 8.382 6.96 8.508 6.778 8.508H6.666ZM6.652 11.084C6.26 11.084 6.036 10.86 6.036 10.468V10.328C6.036 9.936 6.26 9.698 6.652 9.698H6.792C7.198 9.698 7.422 9.936 7.422 10.328V10.468C7.422 10.86 7.198 11.084 6.792 11.084H6.652Z', fill='white')
                  p(style="font-size: 13px;text-align: justify; line-height: 15px; margin: -5px 5px 12px 0px;") Antes de continuar, &nbsp;
                    strong verifica que tu correo electrónico y número de celular sean los correctos
                    |.
                    br
                    br
                    | Toda comunicación respecto a tu caso será notificada por cualquiera de estos medios.
            .section-solicitud-datos(v-if="sectionNarracion")
              v-layout.row-mp-subtitle(:style="narracionComprimido ? {'border-bottom': '1px solid #E7EAED'} : {}")
                v-flex(lg9)
                  .row
                    h4.omnesRegular.mp-subtitle 3. Narración del siniestro (Obligatorio)
                  .row
                    h5.omnesRegular.mp(v-if="form.narracion && narracionComprimido" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 250px; padding-left: 20px;")
                      | {{form.narracion}}
                v-flex.col-mp-button(lg3 style="display: flex;align-items: center; justify-content: flex-end;")
                  span(@click="narracionComprimido = !narracionComprimido" :style="narracionComprimido ? {'font-weight': '500', 'margin-top': '-5px'} : {'font-weight': '700', 'margin-top': '-5px'}") Editar
                  svg(width="7" height="12" viewBox="0 0 8 16" fill="none" :class="(narracionComprimido)?'arrow-down':'arrow-up'" xmlns="http://www.w3.org/2000/svg" style="align-self: center;")
                    path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")

              .section-data-content(v-if="!narracionComprimido")
                v-layout.row-mp-data(v-if="showFechaOcurrencia()")
                  date-picker(label="Fecha de ocurrencia" style="min-width: 50%" @changeDate="(date) => form.fechaOcurrencia = date" :max="currentDateCalendar")
                //- FECHAS INCAPACIDAD
                v-layout.row-mp-data(v-if="showFechasIncapacidad()")
                  p(style="text-align: justify;") Fechas de incapacidad:
                v-layout.row-mp-data(v-if="showFechasIncapacidad()" v-for="(fecha, index) of form.fechasIncapacidad" :key="index" style="align-items:baseline;")
                  date-picker(label="Fecha inicio" @changeDate="(date) => form.fechasIncapacidad[index].fechaInicioIncapacidad = date")
                  date-picker(label="Fecha fin" @changeDate="(date) => form.fechasIncapacidad[index].fechaFinIncapacidad = date")
                  img(v-if="form.fechasIncapacidad.length > 1" :src="images.iconClose" style="cursor: pointer; width: 25px;" @click="removeFechasIncapacidad(index)")
                v-layout.row-mp-data(v-if="showFechasIncapacidad() && form.fechasIncapacidad.length < 4")
                  span.plus-icon2(style="color: #0855C4; font-size: 14px; font-weight: 700; cursor: pointer; padding: 0.3em 1em;" @click="addFechasIncapacidad")
                    i
                      svg(width='16', height='16', viewbox='2 2 32 16', fill='#454A6C', xmlns='http://www.w3.org/2000/svg')
                        path(fill-rule='evenodd', d='M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z', clip-rule='evenodd')
                        path(fill-rule='evenodd', d='M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z', clip-rule='evenodd')
                    | Agregar fechas
                v-layout.row-mp-data(v-if="showMontoSolicitado()")
                  v-text-field(:label="form.tipoPoliza.toLowerCase() === 'soat' ? 'Monto solicitado para gastos médicos':'Monto solicitado'", outline, v-model="form.montoSolicitado" @keydown="(event) => onlyNumbers(event)")
                v-layout.row-mp-data(v-if="showPagador()")
                  v-text-field(label="Nombre del que pagó los gastos médicos", outline, v-model="form.pagador" @keydown="(event) => onlyText(event)")
                v-layout.row-mp-data
                  p(style="text-align: justify;") Puedes contarnos brevemente tu caso y si lo deseas nos pondremos en contacto contigo.
                v-layout.row-mp-data
                  v-textarea(:label="form.narracion.length > 0 ? '' : 'Cuéntanos aquí...'", :class="form.narracion.length > 0 ? 'without-placeholder' : ''", outline, v-model="form.narracion", :maxlength="250")
                v-layout.row-mp-data
                  p(style="margin-left: 15px;margin-top: -15px;font-size: 13px;") Máximo 250 caracteres.
            .section-solicitud-datos(v-if="sectionMetodoPago")
              v-layout.row-mp-subtitle(:style="metodoPagoComprimido ? {'border-bottom': '1px solid #E7EAED'} : {}")
                v-flex(lg9)
                  .row
                    h4.omnesRegular.mp-subtitle 4. Método de pago
                    v-tooltip(bottom style="z-index: 112 !important;")
                      template(v-slot:activator='{ on, attrs }')
                        svg(style="height: 14px;align-self: center;margin-left: 5px;" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" v-bind="attrs" v-on="on")
                          path(d="M5.61833 11.2367C8.72126 11.2367 11.2367 8.72126 11.2367 5.61833C11.2367 2.51541 8.72126 0 5.61833 0C2.51541 0 0 2.51541 0 5.61833C0 8.72126 2.51541 11.2367 5.61833 11.2367Z" fill="#D0D6E0")
                          path(d="M5.51732 6.7122C5.72044 6.7122 5.86306 6.6504 5.87948 6.51772C5.8972 5.89019 6.33025 5.63477 6.76329 5.35126C7.01558 5.23228 7.22954 5.04509 7.381 4.81085C7.53245 4.5766 7.61534 4.30466 7.6203 4.02577C7.6203 3.15104 6.92233 2.52351 5.7736 2.52351C5.25094 2.50066 4.73917 2.67758 4.34222 3.01836C4.20972 3.1306 4.10088 3.26806 4.02201 3.42276C3.94314 3.57746 3.89582 3.7463 3.88281 3.91945C3.88281 4.39485 4.49262 4.4143 4.50126 4.38794C4.52045 4.07346 4.66274 3.77921 4.89732 3.56889C5.1319 3.35858 5.43989 3.24914 5.75458 3.26427C6.39075 3.26427 6.75292 3.591 6.75292 4.09492C6.75292 4.55433 6.36396 4.72244 5.96635 4.98737C5.71309 5.12804 5.50295 5.33506 5.3585 5.58619C5.21406 5.83731 5.14077 6.12305 5.14651 6.4127C5.13743 6.61496 5.29647 6.7122 5.51732 6.7122ZM5.4741 8.4085H5.5977C5.6626 8.41701 5.72859 8.41066 5.79068 8.38993C5.85277 8.3692 5.90934 8.33465 5.95612 8.28886C6.00291 8.24308 6.03868 8.18727 6.06074 8.12564C6.0828 8.06401 6.09057 7.99818 6.08347 7.9331V7.82722C6.09146 7.76134 6.08438 7.69451 6.06277 7.63176C6.04116 7.56902 6.00558 7.512 5.95871 7.46501C5.91185 7.41802 5.85493 7.38229 5.79224 7.36051C5.72955 7.33873 5.66274 7.33148 5.59684 7.33929H5.47323C5.40831 7.33286 5.34277 7.3411 5.28145 7.3634C5.22014 7.3857 5.16461 7.42148 5.11898 7.46811C5.07335 7.51474 5.03877 7.57102 5.0178 7.6328C4.99683 7.69459 4.99001 7.76029 4.99784 7.82506V7.93094C4.99009 7.99533 4.99704 8.06064 5.01816 8.12195C5.03928 8.18327 5.07402 8.239 5.11977 8.28496C5.16553 8.33092 5.2211 8.36591 5.28232 8.38731C5.34354 8.40871 5.40881 8.41596 5.47323 8.4085H5.4741Z" fill="white")
                      span.tooltip-poput(style="color:#FFF;") La cuenta bancaria registrada se utilizará <br> en el caso la solucitud sea procesada.
                v-flex.col-mp-button(lg3 style="display: flex; align-items: center; justify-content: flex-end;")
                  span(@click="metodoPagoComprimido = !metodoPagoComprimido" :style="metodoPagoComprimido ? {'font-weight': '500', 'margin-top': '-5px'} : {'font-weight': '700', 'margin-top': '-5px'}") Editar
                  svg(width="7" height="12" viewBox="0 0 8 16" fill="none" :class="(metodoPagoComprimido)?'arrow-down':'arrow-up'" xmlns="http://www.w3.org/2000/svg" style="align-self: center;")
                    path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")

              .section-data-content(v-if="!metodoPagoComprimido")
                v-layout.row-mp-data
                  p(v-if="form.tipoPoliza.toLowerCase() === 'vida'") En caso tu solicitud sea aprobada, elige cómo recibir tu pago por transferencia o cobrarlo en ventanilla.
                  p(v-else) En caso tu solicitud sea aprobada, elige cómo recibir tu pago por transferencia o cobrarlo en ventanilla.
                v-layout.row-mp-data
                  .box-blue-rounded
                    i
                      svg(width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg")
                        path(d="M8 15C6.14348 15 4.36301 14.2625 3.05025 12.9497C1.7375 11.637 1 9.85652 1 8C1 6.14348 1.7375 4.36301 3.05025 3.05025C4.36301 1.7375 6.14348 1 8 1C9.85652 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85652 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85652 15 8 15ZM8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16Z" fill="white")
                        path(d="M7.00201 11.0001C7.00201 10.8688 7.02788 10.7388 7.07813 10.6174C7.12839 10.4961 7.20205 10.3859 7.29491 10.293C7.38777 10.2002 7.49801 10.1265 7.61933 10.0762C7.74066 10.026 7.87069 10.0001 8.00201 10.0001C8.13334 10.0001 8.26337 10.026 8.3847 10.0762C8.50602 10.1265 8.61626 10.2002 8.70912 10.293C8.80198 10.3859 8.87564 10.4961 8.92589 10.6174C8.97615 10.7388 9.00201 10.8688 9.00201 11.0001C9.00201 11.2653 8.89666 11.5197 8.70912 11.7072C8.52158 11.8948 8.26723 12.0001 8.00201 12.0001C7.7368 12.0001 7.48244 11.8948 7.29491 11.7072C7.10737 11.5197 7.00201 11.2653 7.00201 11.0001ZM7.10001 4.99512C7.0867 4.86896 7.10005 4.74141 7.13921 4.62075C7.17838 4.50008 7.24247 4.389 7.32733 4.2947C7.4122 4.20041 7.51594 4.12501 7.63183 4.0734C7.74771 4.02179 7.87315 3.99512 8.00001 3.99512C8.12687 3.99512 8.25232 4.02179 8.3682 4.0734C8.48409 4.12501 8.58783 4.20041 8.6727 4.2947C8.75756 4.389 8.82165 4.50008 8.86081 4.62075C8.89998 4.74141 8.91333 4.86896 8.90001 4.99512L8.55001 8.50212C8.53825 8.63989 8.47522 8.76823 8.37337 8.86175C8.27152 8.95528 8.13829 9.00717 8.00001 9.00717C7.86174 9.00717 7.7285 8.95528 7.62666 8.86175C7.52481 8.76823 7.46177 8.63989 7.45001 8.50212L7.10001 4.99512Z" fill="white")
                    p(v-if="form.tipoPoliza.toLowerCase() === 'vida'") Si alguno de los beneficiarios quiere recibir el pago en una cuenta bancaria puedes ingresarlo aquí.
                    p(v-else) Recuerda que puedes optar por una transferencia a tu banco preferido para mayor rapidez y seguridad.
                v-layout.mp-data-beneficiario(v-for="(beneficiario,index) of form.beneficiarios" :key="index" style="flex-direction:column;")
                  v-layout.row-mp-subtitle(:style="beneficiariosComprimidos[index] ? {'border-bottom': '1px solid #E7EAED', 'margin': '10px'} : {'margin': '10px'}")
                    v-flex(lg9 style="display: flex; align-items: center; flex-direction: column;")
                      .row(style="width: 100%;")
                        h4.omnesRegular.mp-subtitle {{ 'Beneficiario ' + (index+1) }}
                      .row(style="width: 100%;")
                        h5.omnesRegular.mp(v-if="beneficiariosComprimidos[index]") {{ !beneficiario.titular ? beneficiario.metodoPago : beneficiario.titular }}
                    v-flex.col-mp-button(lg3 style="display: flex;align-items: center; justify-content: flex-end;")
                      span(@click="beneficiarioEditarComprimir(index)" :style="beneficiariosComprimidos[index] ? {'font-weight': '500', 'margin-top': '-5px'} : {'font-weight': '700', 'margin-top': '-5px'}") Editar
                      svg(width="7" height="12" viewBox="0 0 8 16" fill="none" :class="(beneficiariosComprimidos[index])?'arrow-down':'arrow-up'" xmlns="http://www.w3.org/2000/svg" style="align-self: center;")
                        path(d="M0.706024 11.73L6.36302 6.15822L0.706024 0.58646L-0.000976562 1.28281L4.94902 6.15822L-0.000976562 11.0336L0.706024 11.73Z" fill="#0855C4")
                  div(v-if="!beneficiariosComprimidos[index]")
                    v-layout.row-mp-data(v-if="['soat', 'protección tarjeta'].includes(form.tipoPoliza.toLowerCase())")
                      v-select.select-box(solo :items='metodosPago' label="Método de pago" v-model="beneficiario.metodoPago" @change="changeVentanillaTransferencia(index, beneficiario)" :menu-props="selectMenuProps")
                    v-layout.row-mp-data(v-if="beneficiario.metodoPago !== 'Pago en ventanilla Interbank' && mostrarTransferencia")
                      v-text-field(label="Número de cuenta", outline, v-model="beneficiario.nroCuenta", browser-autocomplete="off", @keydown="(event) => onlyNumbers(event, 20)")
                    v-layout.row-mp-data(v-if="mostrarTransferencia || mostrarVentanilla")
                      v-text-field(label="Titular de la cuenta", outline, v-model="beneficiario.titular", browser-autocomplete="off", @keydown="(event) => onlyText(event)")
                    v-layout.row-mp-data(v-if="mostrarTransferencia || mostrarVentanilla")
                      v-text-field(label="N° de documento DNI/CE", outline, v-model="beneficiario.nroDocumento", browser-autocomplete="off" @keydown="(event) => onlyNumbers(event)")
                    v-layout#bancos.row-mp-data(v-if="beneficiario.metodoPago !== 'Pago en ventanilla Interbank' && mostrarTransferencia")
                      //v-select.select-box(solo :items='bancos' label="Banco" v-model="beneficiario.banco" required)
                      v-select.select-box(solo :items="bancos" label="Banco" v-model="beneficiario.banco" prepend-inner-icon="help" @click.native="(event) => showDialogBank(event)" required :menu-props="selectMenuProps")
                    v-layout.row-mp-data(v-if="beneficiario.metodoPago !== 'Pago en ventanilla Interbank' && mostrarTransferencia")
                      v-select.select-box(solo :items='monedas' label="Moneda" v-model="beneficiario.moneda" :disabled="['soat', 'protección tarjeta'].includes(form.tipoPoliza.toLowerCase())" :menu-props="selectMenuProps")
                    v-layout.row-mp-data(v-if="beneficiario.metodoPago !== 'Pago en ventanilla Interbank' && mostrarTransferencia")
                      v-select.select-box(solo :items='tiposCuenta' label="Tipo de cuenta" v-model="beneficiario.tipoCuenta" required :menu-props="selectMenuProps")
                    v-layout.row-mp-data(style="margin-top: 20px; justify-content: space-between;")
                      v-btn.btn-solicitud.btn-pink.omnesSemibold(type='button' style="width: 40%; height: 50px;" @click="beneficiarioRemove(index)") Cancelar
                      v-btn.btn-solicitud.btn-blue.omnesSemibold(type='button' style="width: 40%; height: 50px;" :disabled="isDisabledBtnContinue()" @click="beneficiarioAddEdit(index, beneficiario)") Continuar
                v-layout.row-mp-data(v-if="!beneficiarioOpened && getBeneficiarioDisponible()" style="margin: 0 15px;")
                  span#agregar-beneficiario.plus-icon(@click="beneficiarioEditarComprimir()")
                    i
                      svg(width='16', height='16', viewbox='2 2 32 16', fill='#FFFFFF', xmlns='http://www.w3.org/2000/svg')
                        path(fill-rule='evenodd', d='M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z', clip-rule='evenodd')
                        path(fill-rule='evenodd', d='M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z', clip-rule='evenodd')
                    | Ingresar cuenta bancaria de un beneficiario
            .section-botones-solicitud(v-if="sectionBotonesDatos && !beneficiarioOpened")
              v-layout.row-mp-data(style="margin-top: 20px; justify-content: space-between;")
                v-btn.btn-solicitud.btn-pink.omnesSemibold(type='button' style="width: 40%; height: 50px;" @click="goToHome()") Cancelar
                v-btn.btn-solicitud.btn-blue.omnesSemibold(type='button' style="width: 40%; height: 50px;" :disabled="!validateForm()" @click="nextStep") Continuar
      v-flex.view_myproduct(xs0 sm0 md5 lg4 v-if="sectionDocumentos")
        v-layout
          v-flex.myproduct.document-loads(v-if="sectionDocumentos")
            h2.omnesMedium.mp-title.only-desktop Documentos
            .section-solicitud-datos(v-if="sectionSolicitante")
              v-layout.row-mp-subtitle(:style="solicitanteComprimido ? {'border-bottom': '1px solid #E7EAED'} : {}")
                v-flex(lg12)
                  h4.omnesRegular.mp-subtitle {{ `${this.validateSoatVida() ? '5.' : '4.'} Carga de documentos`}}
              .section-data-content.section-document-loads
                v-layout.row-mp-data
                  p Adjunta los documentos para evaluar tu solicitud.
                v-layout.row-mp-data
                  .box-blue-rounded
                    p {{ `Formatos permitidos: PDF, JPEG o PNG. Cada uno con un peso máximo de ${sizeText}MB.` }}
                v-layout.row-mp-data
                  p(style="margin-left: 10px; margin-right: 10px; margin-top: -5px; font-size: 12px;line-height: 15px;")
                    | {{ `Agrega un total de ${validateSoatVida() ? '4' : '5'} documentos ${validateSoatVida() ? 'extra' : ''} que apoyen a la evaluación de la solicitud de ser necesario.`}}
                div(v-if="!validateSoatVidaProteccion()")
                  // ARCHIVOS EXTTRAS
                  v-layout.row-mp-subtitle(v-for="(file, indexF) in files" :key="'document-'+indexF" style="margin-top: -10px;")
                    v-flex.col-mp-button(lg1)
                      img#attachments-release(:src="images.iconDoc" style="width: 15px;")
                    v-flex(lg10 style="margin: 0px;padding-left: 10px;height: 30px;")
                      .row
                        .box-blue-rounded-file(style="margin-left: 20px;")
                          p(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;") {{file.name}}
                    v-flex.col-mp-button(lg1 style="display: flex; align-items: center; justify-content: center;")
                      img#attachments-release(:src="images.iconClose" style="cursor: pointer; width: 25px;" @click="removeExtraFile(file.name, indexF)")
                  v-layout.row-mp-subtitle(v-if="files.length < (this.validateSoatVidaProteccion() ? 4 : 5)" style="margin-top: -10px; margin-bottom: 0;")
                    span.plus-icon2(@click="uploadExtraFile()")
                      i
                        svg(width='16', height='16', viewbox='2 2 32 16', fill='#454A6C', xmlns='http://www.w3.org/2000/svg')
                          path(fill-rule='evenodd', d='M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z', clip-rule='evenodd')
                          path(fill-rule='evenodd', d='M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z', clip-rule='evenodd')
                      | Subir archivo.
                div(v-if="validateSoatVidaProteccion()" v-for="(cobertura, indexC) in files" :key="indexC")
                  v-layout.row-mp-data
                    p(style="margin: 10px 0px 20px;") {{cobertura.name}}
                  v-layout.row-mp-subtitle(v-for="(doc, index) in cobertura.documents" :key="'doc-'+index" style="border-bottom: 1px solid #E7EAED; margin-top: -7px;")
                    v-flex.col-mp-button(lg1 style="display: flex; align-items: flex-start; justify-content: flex-start;")
                      img#attachments-release(:src="images.iconDoc" style="width: 15px;")
                    v-flex(lg10 style="margin: 0px;padding-left: 10px;height: 55px;")
                      .row
                        h4.omnesRegular.mp-subtitle {{doc.name}}
                      .row(v-if="doc.uploaded")
                        .box-blue-rounded-file
                          p(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;") {{doc.filename}}
                    v-flex.col-mp-button(lg1 style="display: flex; align-items: center; justify-content: center;")
                      img#attachments-release(v-if="!doc.uploaded" :src="images.iconCloud" style="cursor: pointer; width: 25px;" @click="uploadFile(cobertura.name, doc.name)")
                      img#attachments-release(v-if="doc.uploaded" :src="images.iconClose" style="cursor: pointer; width: 25px;" @click="removeFile(cobertura.name, doc.name)")
                  // ARCHIVOS EXTTRAS
                  v-layout.row-mp-subtitle(v-for="(add, indexA) in cobertura.additional" :key="'additional-'+indexA" style="margin-top: -10px;")
                    v-flex.col-mp-button(lg1)
                      img#attachments-release(:src="images.iconDoc" style="width: 15px;")
                    v-flex(lg10 style="margin: 0px;padding-left: 10px;height: 30px;")
                      .row
                        .box-blue-rounded-file(style="margin-left: 20px;")
                          p(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 150px;") {{add.name}}
                    v-flex.col-mp-button(lg1 style="display: flex; align-items: center; justify-content: center;")
                      img#attachments-release(:src="images.iconClose" style="cursor: pointer; width: 25px;" @click="removeExtraFile(cobertura.name, indexA)")
                  v-layout.row-mp-subtitle(v-if="cobertura.additional.length < validateSoatVida() ? 4 : 5" style="margin-top: -10px; margin-bottom: 0;")
                    span.plus-icon2(@click="uploadExtraFile(cobertura.name)")
                      i
                        svg(width='16', height='16', viewbox='2 2 32 16', fill='#454A6C', xmlns='http://www.w3.org/2000/svg')
                          path(fill-rule='evenodd', d='M10 5.5a.5.5 0 01.5.5v4a.5.5 0 01-.5.5H6a.5.5 0 010-1h3.5V6a.5.5 0 01.5-.5z', clip-rule='evenodd')
                          path(fill-rule='evenodd', d='M9.5 10a.5.5 0 01.5-.5h4a.5.5 0 010 1h-3.5V14a.5.5 0 01-1 0v-4z', clip-rule='evenodd')
                      | Subir archivo extra.
                input#inputfile.uploadFile(style="display:none" type="file" name="filename" ref="filesInput" @change="previewFile($event)" accept="image/*,application/pdf")
                input#inputfile.uploadFile(style="display:none" type="file" name="filename" ref="extraFilesInput" @change="previewExtraFile($event)" accept="image/*,application/pdf")
                v-layout.row-mp-data(style="margin-top: 0px;")
                  ul
                    li.conditions-policy Al continuar acepto las &nbsp;
                      a(href="https://www.interseguro.pe/wp-content/uploads/2020/09/Poli%CC%81tica%20de%20Privacidad%20Interseguro.pdf" target="_blank") condiciones de uso y políticas de privacidad.
                v-layout.row-mp-data(style="margin-top: 0px;")
                  v-checkbox(v-model='selectedDataPolicy')
                    template(v-slot:label='')
                      div(:class="selectedInsuredCopy ? 'checked' : 'unchecked'" style="font-size: 13px; line-height: 14px;")
                        | Acepto el  tratamiento de los datos personales.
                v-layout.row-mp-data(v-if="form.tipoPoliza.toLowerCase() === 'protección tarjeta'" style="margin-top: -40px;")
                  v-checkbox(v-model='form.declaracionJurada')
                    template(v-slot:label='')
                      div.selected-insured-copy(:class="form.declaracionJurada ? 'checked' : 'unchecked'" style="font-size: 13px; line-height: 14px;")
                        | Acepto el intercambio de mis datos en el sistema financiero
            .section-botones-solicitud(v-if="sectionBotonesDocumentos && !beneficiarioOpened")
              v-layout.row-mp-data(style="margin-top: 20px; justify-content: space-between;")
                v-btn.btn-solicitud.btn-pink.omnesSemibold(type='button' style="width: 40%; height: 50px;" @click="goToHome()") Cancelar
                v-btn.btn-solicitud.btn-blue.omnesSemibold(type='button' style="width: 40%; height: 50px;" :disabled="!validateForm()" @click="nextStep") Continuar
      v-flex.view_myproduct(xs0 sm0 md5 lg4 v-if="sectionResumen")
        v-layout
          v-flex.myproduct(v-if="sectionResumen" style="padding: 10px;")
            h2.omnesMedium.mp-title.justify-center(style="padding: 0 10px 10px 0; text-align: center;") Resumen de Solicitud
            v-layout.resumen-data
              v-flex(xs12 sm12 md12 lg12)
                v-layout
                  v-flex(xs6 sm6 md6 lg6)
                    p.label-resumen Datos del {{form.tipoPoliza.toLowerCase() === 'soat' ? 'lesionado' : 'asegurado'}}:
                  v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                    p.text-resumen {{form.asegurado.nombres.split(' ')[0] + ' ' + form.asegurado.apellidoPaterno}}
                v-layout
                  v-flex(xs6 sm6 md6 lg6)
                    p.label-resumen Datos del solicitante:
                  v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                    p.text-resumen {{form.solicitante.nombres.split(' ')[0] + ' ' + form.solicitante.apellidoPaterno}}
                v-layout(v-if="validateSoatVidaProteccion()")
                  v-flex(xs6 sm6 md6 lg6)
                    p.label-resumen Método de pago:
                  v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                    p.text-resumen {{ getMetodoPago() }}
                v-layout
                  h4.omnesMedium.mp-title(style="text-decoration: underline; border-bottom: none; padding: 0 10px 10px 0;") Coberturas solicitadas:
                v-layout
                  v-flex(xs6 sm6 md6 lg6)
                    p.label-resumen Documentos adjuntos:
                  v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                    p.text-resumen {{ countDocuments() }} &nbsp; documentos
                div(v-if="validateSoatVida()" v-for="(cobertura, indexC) in files" :key="indexC" :style="indexC < (files.length - 1) ? 'border-bottom: 1px solid #E7EAED;':''")
                  v-layout(v-for="(document, indexD) in cobertura.documents" :id="'documents-'+indexD" :key="'documents-'+indexD")
                    v-flex(xs6 sm6 md6 lg6)
                      p.label-resumen(v-if="indexD === 0") {{cobertura.name}}
                    v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                      p.text-resumen(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;") {{ document.filename }}
                  v-layout(v-for="(document, indexA) in cobertura.additional" :id="'additional-'+indexA" :key="'additional-'+indexA")
                    v-flex(xs6 sm6 md6 lg6)
                    v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                      p.text-resumen(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;") {{ document.name }}
                div(v-else)
                  v-layout.test(v-for="(document, indexFiles) in getFiles()" :id="'files-'+indexFiles" :key="'files-'+indexFiles")
                    //- v-flex(xs6 sm6 md6 lg6) &nbsp;
                    v-flex(xs12 sm12 md12 lg12 style="text-align: right;")
                      p.text-resumen(style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;") {{ document.name }}
                v-layout(style="margin-top: 10px;")
                  v-flex(xs6 sm6 md6 lg6)
                    p.label-resumen Fecha de solicitud:
                  v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                    p.text-resumen {{ new Date().toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: 'numeric'}) }}
            .section-botones-solicitud
              v-layout(row wrap justify-center style="margin-top: 20px;")
                v-btn.btn-solicitud.btn-pink-filled.omnesSemibold(type='button' style="width: 40%; height: 50px;" :disabled="!validateForm()" @click="nextStep") Registrar solicitud
              v-layout(row wrap justify-center style="margin-top: 20px;")
                a.btn-volver(@click="goBack()") Volver
      v-flex.view_myproduct(xs0 sm0 md5 lg4 v-if="sectionFinal")
        v-layout
          v-flex.myproduct(v-if="sectionFinal" style="padding: 20px;")
            v-layout
              v-flex.g-flex.justify-center
                img.justify-center(:src="images.iconSuccess")
            h3.omnesMedium.mp-title.justify-center(style="border: none; text-align: center;") ¡Solicitud ingresada con éxito!
            v-layout.resumen-data
              v-flex(xs12 sm12 md12 lg12)
                v-layout
                  p.omnesRegular.justify-center(style="width: 100%; padding: 10px; text-align: center;")
                    | La respuesta de tu solicitud <br> N° {{nroCaso}} <br> será enviada a tu correo electrónico <br> en un tiempo aproximado de {{ responseRequestTwoDays ? '2': '8'}} días.
                //- v-layout.justify-center
                //-   h4.omnesRegular.text-blue(style="text-align: center;") En caso de tener alguna duda de tu solicitud,<br> por favor escríbenos a nuestro &nbsp;
                //-     a.omnesMedium.text-blue(href="https://wa.me/5115000000" target="_blank") WhatsApp
                //-     | .
            .section-botones-solicitud
              v-layout(row wrap justify-center style="margin-top: 10px;")
                v-btn.btn-solicitud.btn-pink-filled.omnesSemibold(type='button' style="width: 70%; height: 50px;" @click="goToHome()") Volver al menú principal
              v-layout(row wrap justify-center style="margin-top: 10px;" v-if="this.isPhase2")
                v-btn.btn-solicitud.btn-blue.omnesSemibold(type='button' style="width: 70%; height: 50px;" @click="goToHome()") Seguimiento de la solicitud
              v-layout(row wrap justify-center style="margin-top: 20px;")
                p(style="font-style: normal; font-weight: 400; font-size: 12px; line-height: 13px; letter-spacing: 0.005em; color: #454A6C; padding: 20px; text-align: justify;")
                  | La aceptación del registro no implica la aprobación del siniestro ni la presentación completa de los requisitos mínimos obligatorios.

  // SECTION QUERY
  #section-consulta(v-if="sectionConsulta")
    .section-content
      h2 Consulta el estado de tu solicitud
      v-layout(row wrap justify-center style="margin-top: 10px; margin-bottom: 25px;")
        p(style="width: 80%; padding: 0 2rem; text-align: center") Ingresa el número de solicitud enviado a tu correo electrónico
      v-layout(row wrap justify-center style="margin-bottom: 40px;")
        v-flex.container(xs0 sm0 md4 lg4 v-if="sectionConsulta")
          v-layout(row wrap justify-center style="width: 70%; margin: auto; margin-bottom: 80px;")
            v-layout.row-mp-data
              v-text-field(label="Número de solicitud", outline, v-model="caseId")
          v-layout(row wrap justify-center)
            v-btn.btn-solicitud.btn-pink-filled.omnesSemibold#btn-coverages(type='button' :disabled="caseId.length < 8" @click="querySinister()" style="height: 50px;") Siguiente
          v-layout(row wrap justify-center style="margin-top: 20px;")
            a.btn-volver(@click="goToHome()") Volver
  #section-consulta(v-if="sectionResultado")
    .section-content
      h2 Estado de tu solicitud
      v-layout(row wrap justify-center style="margin-bottom: 40px;")
        v-flex.container(xs0 sm0 md4 lg4)
          v-layout.resumen-data
            v-flex(xs10 sm10 md10 lg10 style="margin: auto;")
              v-layout
                //- .slider-component
                  .slidecontainer
                    span {{sinisterCase.value || 0}} %
                    input.slider(v-model='sinisterCase.value', type='range', min='0', max='100', :disabled='true')
                .progress-bar-component
                  .progress-bar-container
                    .progress-bar
                      span(:style="(sinisterCase.value || 0) ? 'color: #0855C4' : ''") {{sinisterCase.value || 0}} %
                      .progress(:style="`width: ${sinisterCase.value || 0}%`")
                      .marker(:style="`top: -7px; left: calc(${sinisterCase.value || 0}% - 5px);`")
                      span(v-if="caseStatus !== 'rechazado' && (sinisterCase.value || 0) === 100" style="color: #0855C4; top: 5px;") Solicitud respondida
              v-layout
                v-flex(xs6 sm6 md6 lg6)
                  p.label-resumen Estado de Solicitud:
                v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                  p.text-resumen
                    span.button-decoration(:class="caseStatus") {{ sinisterCase.status }}
              v-layout
                v-flex(xs6 sm6 md6 lg6)
                  p.label-resumen Fecha de solicitud:
                v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                  p.text-resumen {{ sinisterCase.date }}
              v-layout
                v-flex(xs6 sm6 md6 lg6)
                  p.label-resumen Fecha tentativa de respuesta:
                v-flex(xs6 sm6 md6 lg6 style="text-align: right;")
                  p.text-resumen {{ sinisterCase.dateResponse }}
              v-layout(v-if="caseStatus !== 'pendiente' && caseStatus !== 'evaluacion'")
                v-flex(xs12 sm12 md12 lg12)
                  p.label-resumen(style="font-size: 14px; text-align: center; margin-top:40px;")
                    | {{ `${sinisterCase.status.toLowerCase() === 'aprobado' ? 'Hemos aprobado su solicitud. La información será enviada, dentro de los 2 días hábiles, al correo proporcionado': 'Su caso ha sido respondido. Hemos enviado la información al mail registrado en la solicitud'}: ${sinisterCase.email}.`}}
              v-layout(v-if="caseStatus === 'evaluacion' && flagEvaluationDelaying")
                v-flex(xs12 sm12 md12 lg12)
                  p.label-resumen(style="font-size: 14px; text-align: center; margin-top:40px;")
                    | La evaluación está tomando más tiempo de lo esperado. Por favor, espera un poco más de tiempo y te avisaremos al correo electrónico cuando tengamos una respuesta.
          v-layout(row wrap justify-center)
            v-btn.btn-solicitud.btn-pink-filled.omnesSemibold#btn-coverages(type='button' :disabled="caseId.length === 0" @click="goToHomeFromQuery()" style="margin-top: 24px; height: 50px;") Aceptar
          v-layout(row wrap justify-center style="margin-top: 20px;")
            a.btn-volver(@click="goBackToConsulta()") Volver

  loader-generic(:loader="loader", :textLoader="textLoader")
</template>
<script>
import siniestro from './../interfaces/siniestros'
import { mapActions } from 'vuex'
import { getHashIS } from '../interfaces/sha256'

import DatePicker from '../components/DatePicker.vue'

import Loader from '@/components/Loader.vue'

export default{
  components: {
    'loader-generic': Loader,
    'date-picker': DatePicker
  },
  data: () => ({
    sizeMb: 4194304,
    sizeText: '4',
    caseStatus: '',
    vueWidgtId: 0,
    captchaValid: false,
    sectionCaptcha: true,
    siteKey: process.env.CAPTCHA_KEY,
    loader: false,
    textLoader: '',
    images: {
      iconDoc: require('./../assets/icons/icon-document.svg'),
      iconCloud: require('./../assets/icons/icon-nube.svg'),
      iconClose: require('./../assets/icons/icon-close-pink.svg'),
      iconSuccess: require('./../assets/icons/icon-success.svg')
    },
    sectionPrincipal: true,
    sectionRegistroSiniestro: false,
    sectionMenu: false,
    sectionSubMenu: false,
    sectionSolicitud: false,
    stepperPoint: 1,
    // Datos generales
    coberturasSeleccionadas: [],
    // Secciones
    sectionBotonesDatos: false,
    sectionBotonesDocumentos: false,
    sectionSolicitante: false,
    sectionNarracion: false,
    sectionMetodoPago: false,
    sectionDatos: false,
    sectionDocumentos: false,
    sectionResumen: false,
    sectionFinal: false,
    sectionConsulta: false,
    sectionResultado: false,
    // Comprimidos
    aseguradoComprimido: false,
    solicitanteComprimido: false,
    narracionComprimido: false,
    metodoPagoComprimido: false,
    // CurrentStep
    currentStep: 0,
    // Data form
    caseId: '',
    sinisterCase: {
      value: 0,
      status: '',
      date: '',
      dateResponse: ''
    },
    form: {
      asegurado: {
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        nroDocumento: ''
      },
      solicitante: {
        apellidoPaterno: '',
        apellidoMaterno: '',
        nombres: '',
        nroDocumento: '',
        correo: '',
        celular: ''
      },
      beneficiarios: [],
      narracion: '',
      fechaOcurrencia: '',
      montoSolicitado: '',
      fechasIncapacidad: [
        {
          fechaInicioIncapacidad: '',
          fechaFinIncapacidad: ''
        }
      ],
      pagador: '',
      declaracionJurada: true
    },
    datePicker: false,
    esLocale: {
      firstDayOfWeek: 1,
      weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
    },
    selectedInsuredCopy: false,
    selectedDataPolicy: false,
    mostrarTransferencia: false,
    mostrarVentanilla: false,
    selectMenuProps: {
      offsetY: true,
      maxHeight: 300,
      contentClass: 'siniestro-select-menu'
    },
    beneficiarioCuenta: {
      metodoPago: null,
      nroCuenta: '',
      titular: '',
      nroDocumento: '',
      banco: null,
      moneda: null,
      tipoCuenta: null
    },
    beneficiarioOpened: false,
    beneficiariosComprimidos: [],
    metodosPago: ['Transferencia bancaria', 'Pago en ventanilla Interbank'],
    bancos: ['BCP', 'Interbank', 'Scotiabank', 'BBVA'],
    tiposCuenta: ['Ahorro', 'Corriente'],
    monedas: ['Soles', 'Dólares'],
    lockedSave: false,

    dataCoberturas: [],
    files: [],
    actualInputFile: {},
    actualextraFile: '',
    nroCaso: '',
    isPhase2: true,
    showErrorMessage: false,
    responseRequestTwoDays: false,
    flagEvaluationDelaying: false,
    currentDateCalendar: new Date(new Date() - 5 * 60 * 60 * 1000).toISOString().substr(0, 10),
    coberturasPreviasSeleccionadas: []
  }),
  methods: {
    ...mapActions('sinisters', ['saveSinister', 'getSinister']),
    execute () {
      window.grecaptcha.execute(this.vueWidgtId)
    },
    reset () {
      // reset using vuejs
      window.grecaptcha.reset(this.vueWidgtId)
    },
    render () {
      // render Functions using vuejs
      if (window.grecaptcha) {
        try {
          this.vueWidgtId = window.grecaptcha.render('g-recaptcha', {
            sitekey: this.siteKey, // get your sitekey
            size: 'normal',
            callback: (results) => {
              this.$emit('verify', results)
              this.captchaValid = true
            }
          })
          console.log('this.vueWidgtId: ', this.vueWidgtId)
          return true
        } catch (e) {
          console.log('Error al renderizar captcha: ', e)
        }
      }
      return false
    },
    validate (params) {
      console.log(params)
    },
    onlyText (evt) {
      const re = /[^A-Za-z]/g
      if (evt.key.match(re) && evt.keyCode !== 32) {
        evt.preventDefault()
      }
      if (!evt.target.value.match(re) && evt.keyCode !== 32) {
        evt.target.value = evt.target.value.replace(re, '')
      }
    },
    onlyNumbers (evt, max) {
      const special = ['Backspace', 'Delete', 'ArrowRight', 'ArrowLeft'].includes(evt.key.toString())
      const re = /^\d+$/
      if (!evt.key.toString().match(re) && !special) {
        evt.preventDefault()
      }
      if (max && evt.target.value.length >= max && !special) {
        evt.target.value = evt.target.value.slice(0, max)
        evt.preventDefault()
      }
      if (!evt.target.value.toString().match(re) && !special && evt.target.value) {
        evt.target.value = evt.target.value.replace(re, '')
        evt.preventDefault()
      }
    },
    limpiarForm () {
      this.form = {
        asegurado: {
          apellidoPaterno: '',
          apellidoMaterno: '',
          nombres: '',
          nroDocumento: ''
        },
        solicitante: {
          apellidoPaterno: '',
          apellidoMaterno: '',
          nombres: '',
          nroDocumento: '',
          correo: '',
          celular: ''
        },
        beneficiarios: [],
        narracion: ''
      }
      this.selectedInsuredCopy = false
      this.selectedDataPolicy = false
    },
    goToHome () {
      this.$router.go(0)
    },
    goToHomeFromQuery () {
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Estado de solicitud - Paso 2 - Solicitud recibida',
        'label': this.caseId + ' - ' + this.sinisterCase.status
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Estado de solicitud - Paso 2 - Solicitud recibida',
        'CTA': this.caseId + ' - ' + this.sinisterCase.status
      })
      this.$router.go(0)
    },
    goBack () {
      this.sectionBotonesDatos = false
      this.sectionBotonesDocumentos = true
      this.sectionDatos = true
      this.sectionDocumentos = true
      this.sectionResumen = false
      this.sectionFinal = false
      // Comprimidos
      this.aseguradoComprimido = true
      this.solicitanteComprimido = true
      this.narracionComprimido = true
      this.currentStep--
      window.scrollTo(0, 0)
    },
    hideCaptcha () {
      if (process.env.NODE_ENV !== 'development') {
        document.getElementById('g-recaptcha').firstChild.style.display = 'none'
      }
    },
    goBackToRegistro () {
      // AMPLITUDE
      this.$amplitude.getInstance().logEvent('RCS - Solicitud de Siniestro', { 'Solicitud de Siniestro': 'Registro de Siniestro' })
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Seleccionar solicitud',
        'label': 'Registra tu siniestro'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_icon',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'icon_Continuar',
        'TipoAccion': 'Seleccionar solicitud',
        'CTA': 'Registra tu siniestro'
      })
      this.sectionPrincipal = false
      this.sectionRegistroSiniestro = true
      this.sectionSubMenu = false
      this.sectionSolicitud = false
      this.sectionStepper = false
      this.sectionBotonesDatos = false
      this.sectionMenu = true
      this.sectionCaptcha = false
      window.scrollTo(0, 0)
    },
    goToRegistro () {
      // AMPLITUDE
      this.$amplitude.getInstance().logEvent('RCS - Solicitud de Siniestro', { 'Solicitud de Siniestro': 'Registro de Siniestro' })
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Seleccionar solicitud',
        'label': 'Registra tu siniestro'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_icon',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'icon_Continuar',
        'TipoAccion': 'Seleccionar solicitud',
        'CTA': 'Registra tu siniestro'
      })

      // POPUP MANTENIMIENTO
      /*
      this.$swal({
        imageUrl: require('@/assets/img/character/sorprendido.svg'),
        imageHeight: 150,
        imageWidth: 150,
        html: '<p class="omnesRegular g-text-gray-700">Lo sentimos. En este momento la funcionalidad se encuentra en mantenimiento, envíanos tu caso al siguiente correo: <b class="omnesSemibold g-text-gray-700">siniestros.sac@interseguro.com.pe</b></p>',
        confirmButtonColor: '#EA0D90',
        confirmButtonText: 'Entendido'
      })
      */

      if (process.env.NODE_ENV !== 'development' && !this.captchaValid) {
        window.scrollTo(0, 280)
        return
      }
      this.hideCaptcha()
      const date = localStorage.getItem('lastSinisterDate')
      if (date) {
        const now = new Date()
        const last = new Date(date)
        const diff = now - last
        if (process.env.NODE_ENV === 'production' && diff / (1000 * 60) < 30) {
          this.$swal({
            text: 'Debe esperar 30 minutos para registrar un siniestro nuevo.',
            imageUrl: require('./../assets/img/character/informa.svg'),
            imageHeight: 150,
            imageWidth: 150,
            showCancelButton: false,
            confirmButtonColor: '#EA0C90',
            confirmButtonText: 'Entendido'
          })
          return
        } else {
          localStorage.removeItem('lastSinisterDate')
        }
      }
      this.sectionPrincipal = false
      this.sectionRegistroSiniestro = true
      this.sectionSubMenu = false
      this.sectionSolicitud = false
      this.sectionStepper = false
      this.sectionBotonesDatos = false
      this.sectionMenu = true
      this.sectionCaptcha = false
      window.scrollTo(0, 0)
    },
    goBackToConsulta () {
      // AMPLITUDE
      this.$amplitude.getInstance().logEvent('RCS - Solicitud de Siniestro', { 'Solicitud de Siniestro': 'Estado de la Solicitud' })
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Seleccionar solicitud',
        'label': 'Estado de solicitud'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_icon',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'icon_Continuar',
        'TipoAccion': 'Seleccionar solicitud',
        'CTA': 'Estado de solicitud'
      })
      this.sectionCaptcha = false
      this.selectedInsuredCopy = false
      this.selectedDataPolicy = false
      this.sectionCaptcha = false
      this.sectionPrincipal = false
      this.sectionMenu = false
      this.sectionResultado = false
      this.sectionRegistroSiniestro = true
      this.sectionConsulta = true
      this.sectionSubMenu = false
      this.sectionSolicitud = false
      this.sectionStepper = false
      this.sectionBotonesDatos = false
      window.scrollTo(0, 0)
    },
    goToConsulta () {
      // AMPLITUDE
      this.$amplitude.getInstance().logEvent('RCS - Solicitud de Siniestro', { 'Solicitud de Siniestro': 'Estado de la Solicitud' })
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Seleccionar solicitud',
        'label': 'Estado de solicitud'
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_icon',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'icon_Continuar',
        'TipoAccion': 'Seleccionar solicitud',
        'CTA': 'Estado de solicitud'
      })
      if (process.env.NODE_ENV !== 'development' && !this.captchaValid) {
        window.scrollTo(0, 280)
        return
      }
      this.hideCaptcha()
      if (process.env.NODE_ENV !== 'development') {
        this.caseId = ''
        this.sinisterCase = {
          value: 0,
          status: '',
          date: '',
          dateResponse: ''
        }
      }
      this.sectionCaptcha = false
      this.selectedInsuredCopy = false
      this.selectedDataPolicy = false
      this.sectionCaptcha = false
      this.sectionPrincipal = false
      this.sectionMenu = false
      this.sectionResultado = false
      this.sectionRegistroSiniestro = true
      this.sectionConsulta = true
      this.sectionSubMenu = false
      this.sectionSolicitud = false
      this.sectionStepper = false
      this.sectionBotonesDatos = false
      window.scrollTo(0, 0)
    },
    padTo2Digits (num) {
      return num.toString().padStart(2, '0')
    },
    formatDate (date) {
      return [
        this.padTo2Digits(date.getDate()),
        this.padTo2Digits(date.getMonth() + 1),
        date.getFullYear()
      ].join('-')
    },
    querySinister () {
      const self = this
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Estado de solicitud - Paso 1 - Ingresar código',
        'label': this.caseId
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Estado de solicitud - Paso 1 - Ingresar código',
        'CTA': this.caseId
      })
      this.loader = true
      this.textLoader = 'Recopilando información...'
      this.getSinister(this.caseId)
        .then(res => {
          self.loader = false
          if (res.data.length > 0) {
            const sinister = res.data[0]
            const [dd, mm, yyyy] = sinister.FECHA_SOLICITUD.split('-')
            const date = new Date(yyyy, mm - 1, dd)
            this.validateResponseRequestDate(sinister.PRODUCTO)
            const numberDays = this.responseRequestTwoDays ? 2 : 8
            date.setDate(date.getDate() + numberDays)
            const dateResponse = this.formatDate(date)
            self.sinisterCase = {
              status: sinister.ESTADO_DICTAMEN,
              date: sinister.FECHA_SOLICITUD,
              dateResponse: dateResponse,
              email: this.maskEmail(sinister.CORREO_TERCERO)
            }

            // For request status "En evaluación"
            const today = new Date()
            const dateRequest = new Date(yyyy, mm - 1, dd)
            dateRequest.setDate(dateRequest.getDate() + 1)
            if (sinister.ESTADO_DICTAMEN === 'pendiente' && today >= dateRequest) {
              sinister.ESTADO_DICTAMEN = 'en evaluación'
              this.flagEvaluationDelaying = false
              if (today > date) {
                this.flagEvaluationDelaying = true
              }
            }

            self.sinisterCase.status = sinister.ESTADO_DICTAMEN.charAt(0).toUpperCase() + sinister.ESTADO_DICTAMEN.slice(1)

            switch (sinister.ESTADO_DICTAMEN) {
            case 'pendiente':
              self.caseStatus = 'pendiente'
              self.sinisterCase.value = 33
              break
            case 'en evaluación':
              self.caseStatus = 'evaluacion'
              self.sinisterCase.value = 60
              break
            case 'rechazado':
            case 'observado':
              self.caseStatus = 'rechazado'
              self.sinisterCase.value = 100
              break
            default:
              self.caseStatus = 'aprobado'
              self.sinisterCase.value = 100
              break
            }
            self.sectionConsulta = false
            self.sectionResultado = true

            // AMPLITUDE
            const amplitudeData = {
              'Número de Solicitud': self.caseId,
              'Estado de la Solicitud': sinister.ESTADO_DICTAMEN,
              'Fecha de Solicitud(s)': sinister.FECHA_SOLICITUD
            }
            this.$amplitude.getInstance().logEvent('RCS - Estado de Solicitud de Siniestros', amplitudeData)
          } else {
            this.$swal({
              text: 'No se encontró ningún siniestro con el número de solicitud ingresado.',
              imageUrl: require('./../assets/img/character/oops.svg'),
              imageHeight: 150,
              imageWidth: 150,
              showCancelButton: false,
              confirmButtonColor: '#EA0C90',
              confirmButtonText: 'Entendido'
            })
          }
        })
        .catch(err => {
          console.log(err)
          self.loader = false
          this.$swal({
            text: 'No se encontró ningún siniestro con el número de solicitud ingresado.',
            imageUrl: require('./../assets/img/character/oops.svg'),
            imageHeight: 150,
            imageWidth: 150,
            showCancelButton: false,
            confirmButtonColor: '#EA0C90',
            confirmButtonText: 'Entendido'
          })
        })
    },
    goToCoberturas (option) {
      // AMPLITUDE
      this.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Selección de Producto', { 'Producto': option })
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Registro de Siniestro - Paso 1 - Seleccionar producto',
        'label': option
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_icon',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'icon_Continuar',
        'TipoAccion': 'Registro de Siniestro - Paso 1 - Seleccionar producto',
        'CTA': option
      })
      /* if (option === 'otros') {
        this.$swal({
          text: 'Para ingresar tu solicitud por favor comuníquese al (01) 500 0000',
          imageUrl: require('./../assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
        return
      } */

      if (option === 'SOAT') {
        this.$swal({
          imageUrl: require('@/assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          title: 'Registra tu siniestro por WhatsApp',
          html: 'Puedes hacerlo de forma rápida y sencilla. <br>Escríbenos.',
          confirmButtonColor: '#EA0D90',
          confirmButtonText: 'Ir a WhatsApp',
          showCloseButton: true,
          allowOutsideClick: false
        }).then((result) => {
          // Redirige a WhatsApp si el usuario selecciona el botón
          if (result.value) {
            window.open(
              'https://api.whatsapp.com/send?phone=5115000000&text=%C2%A1Hola!%20necesito%20registrar%20mi%20siniestro%20SOAT',
              '_blank'
            )
          }
        })
      }

      this.form.tipoPoliza = option
      this.dataCoberturas = (siniestro.coberturas[option.toLowerCase() || ''] || []).map(cobertura => {
        return {
          ...cobertura,
          selected: false
        }
      })
      this.coberturasSeleccionadas = []
      this.sectionMenu = false
      this.sectionSubMenu = true
      if (this.dataCoberturas.length === 0) {
        this.goToDatos()
        this.sectionSubMenu = false
      }
      window.scrollTo(0, 0)

      this.validateResponseRequestDate(this.form.tipoPoliza)
    },
    selectCobertura (key) {
      const tipoPoliza = this.form.tipoPoliza.toLowerCase()
      const multiProduct = ['soat', 'protección tarjeta'].includes(tipoPoliza)
      const cobertura = this.dataCoberturas.find(c => c.key === key)
      if (this.coberturasSeleccionadas.length === 4 && tipoPoliza === 'soat' && !cobertura.selected) {
        this.$swal({
          text: 'Solo puedes seleccionar hasta 4 coberturas',
          imageUrl: require('./../assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
        return
      }
      cobertura.selected = !cobertura.selected
      if (!multiProduct) {
        this.dataCoberturas = this.dataCoberturas.map(c => {
          if (c.key !== key) {
            c.selected = false
          }
          return c
        })
      }

      // Guarda el estado anterior solo si es 'soat'
      // const seleccionAnteriorCoberturas = tipoPoliza === 'soat' ? [...this.coberturasSeleccionadas] : []

      // Actualiza la lista actual de coberturas seleccionadas según las que están marcadas
      this.coberturasSeleccionadas = this.dataCoberturas.filter(c => c.selected).map(c => c.name)

      /*
      if (tipoPoliza === 'soat') {
        // Verifica si 'Incapacidad Temporal' fue recién agregada
        const incapacidadFueAgregada = !seleccionAnteriorCoberturas.includes('Incapacidad Temporal') && this.coberturasSeleccionadas.includes('Incapacidad Temporal')

        if (incapacidadFueAgregada) {
          this.$swal({
            imageUrl: require('@/assets/img/character/informa.svg'),
            imageHeight: 150,
            imageWidth: 150,
            title: 'Registra tu siniestro por WhatsApp',
            html: 'Puedes hacerlo de forma rápida y sencilla. <br>Escríbenos.',
            confirmButtonColor: '#EA0D90',
            confirmButtonText: 'Ir a WhatsApp',
            showCloseButton: true,
            allowOutsideClick: false
          }).then((result) => {
            // Redirige a WhatsApp si el usuario selecciona el botón
            if (result.value) {
              window.open(
                'https://api.whatsapp.com/send?phone=5115000000&text=%C2%A1Hola!%20necesito%20registrar%20mi%20siniestro%20SOAT',
                '_blank'
              )
            }
          })
        }
        // Actualiza el estado previo con la selección actual
        this.coberturasPreviasSeleccionadas = [...this.coberturasSeleccionadas]
      }
      */
      window.scrollTo(0, 0)
    },
    goToDatos () {
      // AMPLITUDE
      const amplitudeData = {'Producto': this.form.tipoPoliza, 'Cobertura(s)': this.coberturasSeleccionadas}
      this.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Selección de Coberturas', amplitudeData)
      // EVENT TRACK  Universal Analytics
      this.$gtm.trackEvent({
        'event': 'virtualEvent',
        'category': 'Registro y Consulta de Siniestro',
        'action': 'Registro de Siniestro - Paso 2 - Seleccionar cobertura(s) - ' + this.form.tipoPoliza,
        'label': this.coberturasSeleccionadas[0]
      })
      // EVENT TRACK  GA4
      this.$gtm.trackEvent({
        'event': 'select_button',
        'Nombre Sección': 'Registro y Consulta de Siniestro',
        'TipoElemento': 'Botón',
        'TipoAccion': 'Registro de Siniestro - Paso 2 - Seleccionar cobertura(s) - ' + this.form.tipoPoliza,
        'CTA': this.coberturasSeleccionadas[0]
      })

      this.sectionBotonesDocumentos = false
      this.sectionRegistroSiniestro = false
      this.sectionSolicitante = false
      this.sectionNarracion = false
      this.sectionMetodoPago = false
      this.sectionDocumentos = false
      this.sectionDocumentos = false
      this.sectionResumen = false

      this.sectionSubMenu = false
      this.sectionSolicitud = true
      this.sectionDatos = true
      this.sectionStepper = true
      this.sectionBotonesDatos = true

      this.currentStep = 1
      window.scrollTo(0, 0)
    },
    validateForm () {
      if (this.lockedSave) {
        return false
      }
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      let result = true
      if (this.currentStep >= 1) {
        result = result && this.form.asegurado.apellidoPaterno && this.form.asegurado.apellidoMaterno && this.form.asegurado.nombres && this.form.asegurado.nroDocumento
      }
      if (this.currentStep >= 2) {
        result = result && this.form.solicitante.apellidoPaterno && this.form.solicitante.apellidoMaterno && this.form.solicitante.nombres && this.form.solicitante.nroDocumento && this.form.solicitante.correo && this.form.solicitante.celular
        result = result && re.test(this.form.solicitante.correo)
      }
      if (this.currentStep >= 3) {
        const proteccionTarjeta = this.form.tipoPoliza.toLowerCase() === 'protección tarjeta'
        const soat = this.form.tipoPoliza.toLowerCase() === 'soat'

        if (proteccionTarjeta) {
          const fechaOcurrencia = this.form.fechaOcurrencia !== ''
          result = result && (fechaOcurrencia && this.form.montoSolicitado)
        }

        if (soat) {
          const incapacidadTemporal = this.coberturasSeleccionadas.includes('Incapacidad Temporal')
          const gastosMedicos = this.coberturasSeleccionadas.includes('Gastos médicos')

          if (incapacidadTemporal) {
            const fechaOcurrencia = this.form.fechaOcurrencia !== ''
            for (const filaFechas of this.form.fechasIncapacidad) {
              const fechaInicioIncapacidad = filaFechas.fechaInicioIncapacidad && filaFechas.fechaInicioIncapacidad !== ''
              const fechaFinIncapacidad = filaFechas.fechaFinIncapacidad && filaFechas.fechaFinIncapacidad !== ''
              result = result && (fechaOcurrencia && fechaInicioIncapacidad && fechaFinIncapacidad)
            }
          }

          if (gastosMedicos) {
            const fechaOcurrencia = this.form.fechaOcurrencia !== ''
            result = result && (fechaOcurrencia && this.form.montoSolicitado && this.form.pagador)
          }

          result = result && soat
        }

        result = result && (this.form.narracion.trim())
      }
      if (this.currentStep >= 4) {
        for (const beneficiario of this.form.beneficiarios) {
          const transferenciaValid = beneficiario.metodoPago && beneficiario.metodoPago === 'Transferencia bancaria' && beneficiario.nroCuenta && beneficiario.titular && beneficiario.nroDocumento && beneficiario.banco && beneficiario.moneda && beneficiario.tipoCuenta
          const pagoVentanillaValid = beneficiario.metodoPago && beneficiario.metodoPago === 'Pago en ventanilla Interbank'
          result = result && (transferenciaValid || pagoVentanillaValid)
          // result = result && beneficiario.metodoPago && beneficiario.nroCuenta && beneficiario.titular && beneficiario.nroDocumento && beneficiario.banco && beneficiario.moneda && beneficiario.tipoCuenta
        }
      }
      if (this.currentStep >= 5) {
        result = result && this.selectedDataPolicy
      }
      return result
    },
    isDisabledBtnContinue () {
      return false
    },
    getHashId (numeroDocumento) {
      let tipoDocumento = '01'
      if (numeroDocumento.length !== 8) {
        tipoDocumento = '02'
      }
      return getHashIS(tipoDocumento, numeroDocumento)
    },
    nextStep () {
      const self = this
      if (!this.validateForm()) {
        this.$swal({
          text: 'Por favor, llene todos los campos',
          imageUrl: require('./../assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
        return
      }
      if (this.currentStep === 1) {
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'label': 'Datos del asegurado - Seleccionar botón - Continuar'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'CTA': 'Datos del asegurado - Seleccionar botón - Continuar',
          'Cobertura(s)': this.coberturasSeleccionadas
        })
        this.sectionSolicitante = true
        this.aseguradoComprimido = true
      }
      if (this.currentStep === 2) {
        // HashID
        const userId = this.form.asegurado.nroDocumento // Proximamente User-Id sera el hashId: this.getHashId(this.form.asegurado.nroDocumento)
        // AMPLITUDE
        const identify = new self.$amplitude.Identify().set('User-ID', userId).set('Número de Documento', this.form.asegurado.nroDocumento)
          .set('Apellido', (this.form.asegurado.apellidoPaterno + ' ' + this.form.asegurado.apellidoMaterno).trim()).set('Nombre', this.form.asegurado.nombres)
          .set('Email', this.form.solicitante.correo).set('Telefono', this.form.solicitante.celular).set('Usuario Siniestrado(a)', true)
        this.$amplitude.getInstance().identify(identify)
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'label': 'Datos del solicitante - Seleccionar botón - Continuar'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'CTA': 'Datos del solicitante - Seleccionar botón - Continuar',
          'Cobertura(s)': this.coberturasSeleccionadas
        })

        self.$swal({
          title: '<h2 style="color: #0855C4;">¡Recuerda!</h2>',
          text: 'La falta de comunicación oportuna no podrá ser atribuida a Interseguro en caso de que los datos de contacto consignados no sean los correctos.',
          imageUrl: require('./../assets/img/character/oops.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })

        this.sectionNarracion = true
        this.solicitanteComprimido = true
      }
      if (this.currentStep === 3) {
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'label': 'Narración del siniestro - Seleccionar botón - Continuar'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'CTA': 'Narración del siniestro - Seleccionar botón - Continuar',
          'Cobertura(s)': this.coberturasSeleccionadas
        })
        if (this.validateSoatVidaProteccion()) {
          this.sectionMetodoPago = true
          this.narracionComprimido = true
        } else {
          this.currentStep++
        }
      }
      if (this.currentStep === 4) {
        // AMPLITUDE
        const amplitudeData = {
          'Producto': this.form.tipoPoliza,
          'Cobertura(s)': this.coberturasSeleccionadas,
          'Método de Pago': this.form.beneficiarios.map(b => b.metodoPago),
          'Solicitante es Lesionado': this.form.asegurado.nroDocumento === this.form.solicitante.nroDocumento,
          'Narracion Siniestro': this.form.narracion
        }
        this.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Solicitud', amplitudeData)
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'label': 'Método de pago - Seleccionar botón - Continuar'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'CTA': 'Método de pago - Seleccionar botón - Continuar',
          'Cobertura(s)': this.coberturasSeleccionadas
        })

        if (this.form.beneficiarios.length === 0 && this.validateSoatVida()) {
          this.$swal({
            title: '<h2 style="color: #0855C4;">¡Recuerda!</h2>',
            text: 'En caso no ingreses la cuenta bancaria de algún beneficiario, el cobro será por pago en ventanilla del banco Interbank.',
            imageUrl: require('./../assets/img/character/informa.svg'),
            imageHeight: 150,
            imageWidth: 150,
            showCancelButton: false,
            confirmButtonColor: '#EA0C90',
            confirmButtonText: 'Entendido'
          })
        }
        this.files = []
        const rules = siniestro.documentos[this.form.tipoPoliza.toLowerCase() || '']
        this.coberturasSeleccionadas.forEach(c => {
          const documents = []
          for (const document of rules[c]) {
            documents.push({
              name: document,
              uploaded: false
            })
          }
          this.files.push({name: c, documents: documents, additional: []})
        })
        this.sectionBotonesDatos = false
        this.sectionDocumentos = true
        this.sectionBotonesDocumentos = true
      }
      if (this.currentStep === 5) {
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'label': 'Carga de documentos - Seleccionar botón - Continuar'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Paso 3 - Complete la información - ' + this.form.tipoPoliza,
          'CTA': 'Carga de documentos - Seleccionar botón - Continuar',
          'Cobertura(s)': this.coberturasSeleccionadas
        })
        this.sectionDatos = false
        this.sectionDocumentos = false
        this.sectionResumen = true
        this.showFiles = true
        this.stepperPoint = 2
        let allDocs = true
        if (this.validateSoatVida()) {
          for (const cobertura of this.files) {
            allDocs = allDocs && (cobertura.documents.filter(d => d.filename && d.file).length === cobertura.documents.length)
          }
          if (!allDocs) {
            this.$swal({
              text: 'La solicitud se está registrando sin la documentación completa.',
              imageUrl: require('./../assets/img/character/informa.svg'),
              imageHeight: 150,
              imageWidth: 150,
              showCancelButton: false,
              confirmButtonColor: '#EA0C90',
              confirmButtonText: 'Entendido'
            })
          } else {
            this.$swal({
              text: 'En caso de que la solicitud sea aprobada, nos pondremos en contacto contigo a través de un correo electrónico para informarte el medio de pago.',
              imageUrl: require('./../assets/img/character/informa.svg'),
              imageHeight: 150,
              imageWidth: 150,
              showCancelButton: false,
              confirmButtonColor: '#EA0C90',
              confirmButtonText: 'Entendido'
            })
          }
        } else {
          allDocs = this.files.length > 0
          this.$swal({
            text: 'En caso de que la solicitud sea aprobada, nos pondremos en contacto contigo a través de un correo electrónico para informarte el medio de pago.',
            imageUrl: require('./../assets/img/character/informa.svg'),
            imageHeight: 150,
            imageWidth: 150,
            showCancelButton: false,
            confirmButtonColor: '#EA0C90',
            confirmButtonText: 'Entendido'
          })
        }
        window.scrollTo(0, 0)

        // AMPLITUDE
        const amplitudeData = {
          'Producto': this.form.tipoPoliza,
          'Cobertura(s)': this.coberturasSeleccionadas,
          'Método de Pago': this.form.beneficiarios.map(b => b.metodoPago),
          'Documentos adjuntos': this.countDocuments(),
          'Fecha de Solicitud': this.formatDate(new Date())
        }
        this.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Documentos de Siniestro', {'Documentos Completos': allDocs})
        this.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Resumen de Solicitud', amplitudeData)
        // EVENT TRACK  Universal Analytics
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Solicitud completada',
          'label': 'Visualizar Modal - Documentación ' + allDocs ? 'Completa' : 'Incompleta'
        })
        // EVENT TRACK  GA4
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Solicitud completada',
          'CTA': 'Visualizar Modal - Documentación ' + allDocs ? 'Completa' : 'Incompleta'
        })
      }
      if (this.currentStep === 6) {
        // EVENT TRACK  Universal Analytics
        this.lockedSave = true
        this.$gtm.trackEvent({
          'event': 'virtualEvent',
          'category': 'Registro y Consulta de Siniestro',
          'action': 'Registro de Siniestro - Resumen de Solicitud',
          'label': this.form.tipoPoliza + ' - Seleccionar Botón - Registrar solicitud'
        })
        // EVENT TRACK  GA4
        let metodoPago = 'Pago en ventanilla Interbank'
        if (this.form.beneficiarios.length > 0) {
          metodoPago = this.form.beneficiarios[0].metodoPago
        }
        this.$gtm.trackEvent({
          'event': 'select_button',
          'Nombre Sección': 'Registro y Consulta de Siniestro',
          'TipoElemento': 'Botón',
          'TipoAccion': 'Registro de Siniestro - Resumen de Solicitud',
          'CTA': '{Producto} - Seleccionar Botón - {Botón}',
          'Cobertura(s)': this.coberturasSeleccionadas,
          'MetodoPago': metodoPago
        })
        // endpoint
        this.loader = true
        this.textLoader = 'Recopilando información...'
        let formData = new FormData()
        const form = {
          tipoPoliza: this.form.tipoPoliza,
          asegurado: { ...this.form.asegurado },
          solicitante: { ...this.form.solicitante },
          narracion: this.form.narracion,
          fechaOcurrencia: this.form.fechaOcurrencia,
          montoSolicitado: this.form.montoSolicitado,
          pagador: this.form.pagador,
          fechasIncapacidad: this.form.tipoPoliza.toLowerCase() === 'soat' ? this.form.fechasIncapacidad : [],
          declaracionJurada: this.form.tipoPoliza.toLowerCase() === 'protección tarjeta' ? this.form.declaracionJurada : false
        }
        form.beneficiarios = this.form.beneficiarios.map(b => {
          const beneficiario = {
            ...b
          }
          if (b.metodoPago === 'Transferencia bancaria') {
            beneficiario.metodoPago = 'Transferencia'
          } else {
            beneficiario.metodoPago = 'Pago en ventanilla - Interbank'
          }
          return beneficiario
        })

        formData.append('sinister', JSON.stringify(form))
        const attachmentsData = []
        let index = 0
        if (this.validateSoatVidaProteccion()) {
          for (const cobertura of this.files) {
            const attach = {coverage: cobertura.name, documents: [], additional: []}
            for (const document of cobertura.documents) {
              if (document.uploaded) {
                formData.append('attachments', document.file)
                attach.documents.push({
                  name: document.name,
                  filename: document.filename,
                  index
                })
                index++
              }
            }
            for (const document of cobertura.additional) {
              formData.append('attachments', document.file)
              attach.additional.push({
                filename: document.name,
                index
              })
              index++
            }
            attachmentsData.push(attach)
          }
        } else {
          const attach = {coverage: '', documents: [], additional: []}
          for (const document of this.files) {
            formData.append('attachments', document.file)
            attach.additional.push({
              filename: document.name,
              index
            })
            index++
          }
          attachmentsData.push(attach)
        }
        formData.append('attachments_metadata', JSON.stringify(attachmentsData))
        formData.append('environment', process.env.NODE_ENV)
        this.textLoader = 'Enviando solicitud...'

        this.saveSinister(formData)
          .then((res) => {
            self.currentStep++
            self.sectionResumen = false
            self.sectionFinal = true
            self.loader = false
            self.sectionStepper = false
            self.sectionSolicitud = true
            self.nroCaso = res.data.data.cases[0]
            window.scrollTo(0, 0)
            localStorage.setItem('lastSinisterDate', new Date().toISOString())
            self.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Documentos de Siniestro', {'Número de Solicitud': res.data.data.cases})
            this.lockedSave = false
          })
          .catch(err => {
            console.log(err)
            self.loader = false
            self.$amplitude.getInstance().logEvent('RCS - Registro de Siniestro - Documentos de Siniestro', {
              'Error': 'Error al registrar siniestro',
              'Detalle': err
            })
            this.lockedSave = false
            self.$swal({
              title: '<h2 style="color: #0855C4;">¡Parece que algo salió mal!</h2>',
              text: 'Te pedimos disculpas por el inconveniente y solicitamos que vuelvas intentarlo en unos minutos.',
              imageUrl: require('./../assets/img/character/oops.svg'),
              imageHeight: 150,
              imageWidth: 150,
              showCancelButton: false,
              confirmButtonColor: '#EA0C90',
              confirmButtonText: 'Entendido'
            })
          })
      }
      if (this.currentStep < 6) {
        this.currentStep++
      }
    },
    copyInsured () {
      if (this.selectedInsuredCopy) {
        this.form.solicitante.apellidoPaterno = this.form.asegurado.apellidoPaterno
        this.form.solicitante.apellidoMaterno = this.form.asegurado.apellidoMaterno
        this.form.solicitante.nombres = this.form.asegurado.nombres
        this.form.solicitante.nroDocumento = this.form.asegurado.nroDocumento
      } else {
        this.form.solicitante.apellidoPaterno = ''
        this.form.solicitante.apellidoMaterno = ''
        this.form.solicitante.nombres = ''
        this.form.solicitante.nroDocumento = ''
      }
    },
    validateSoatVida () {
      return ['soat', 'vida'].includes(this.form.tipoPoliza.toLowerCase())
    },
    validateSoatVidaProteccion () {
      return ['soat', 'vida', 'protección tarjeta'].includes(this.form.tipoPoliza.toLowerCase())
    },
    getBeneficiarioDisponible () {
      return this.form.beneficiarios.length < (this.form.tipoPoliza.toLowerCase() === 'vida' ? 4 : 1)
    },
    beneficiarioRemove (index) {
      this.form.beneficiarios.splice(index, 1)
      this.beneficiariosComprimidos.splice(index, 1)
      this.beneficiarioOpened = false
    },
    beneficiarioEditarComprimir (index) {
      this.beneficiarioOpened = true
      if (index >= 0) {
        this.beneficiariosComprimidos[index] = !this.beneficiariosComprimidos[index]
      } else {
        let text = ''
        if (this.form.tipoPoliza.toLowerCase() === 'soat') {
          text = 'La cuenta bancaria registrada se utilizará en el caso la solicitud sea procesada.'
        } else {
          text = 'El titular de la cuenta debe coincidir con el beneficiario al que le corresponde la indemnización, caso contrario el pago se realizará por orden de pago en el banco Interbank.'
        }
        this.$swal({
          title: '<h2 style="color: #0855C4;">¡Recuerda!</h2>',
          text: text,
          imageUrl: require('./../assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
        const beneficiario = {...this.beneficiarioCuenta}
        if (['soat', 'protección tarjeta'].includes(this.form.tipoPoliza.toLowerCase())) {
          beneficiario.metodoPago = null
          beneficiario.moneda = 'Soles'
          this.mostrarTransferencia = false
          this.mostrarVentanilla = false
        } else {
          beneficiario.metodoPago = 'Transferencia bancaria'
          this.mostrarTransferencia = true
          this.mostrarVentanilla = false
        }
        this.form.beneficiarios.push({...beneficiario})
        this.beneficiariosComprimidos.push(false)
      }
    },
    beneficiarioAddEdit (index, beneficiario) {
      const transferenciaValid = beneficiario.metodoPago && beneficiario.metodoPago === 'Transferencia bancaria' && beneficiario.nroCuenta && beneficiario.titular && beneficiario.nroDocumento && beneficiario.banco && beneficiario.moneda && beneficiario.tipoCuenta
      const pagoVentanillaValid = beneficiario.metodoPago && beneficiario.metodoPago === 'Pago en ventanilla Interbank'
      if (transferenciaValid || pagoVentanillaValid) {
        this.form.beneficiarios[index] = beneficiario
        this.beneficiariosComprimidos[index] = true
        this.beneficiarioOpened = false
      } else {
        this.$swal({
          text: 'Por favor, llene todos los campos',
          imageUrl: require('./../assets/img/character/informa.svg'),
          imageHeight: 150,
          imageWidth: 150,
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      }
    },
    changeVentanillaTransferencia (index, beneficiario) {
      if (beneficiario.metodoPago === 'Transferencia bancaria') {
        this.mostrarTransferencia = true
        this.mostrarVentanilla = false
      } else {
        this.mostrarTransferencia = false
        this.mostrarVentanilla = false
        beneficiario.nroCuenta = ''
        beneficiario.titular = ''
        beneficiario.nroDocumento = ''
        beneficiario.banco = null
        beneficiario.tipoCuenta = null
        this.beneficiarioAddEdit(index, beneficiario)
        if (this.currentStep < 5) {
          this.nextStep()
        }
      }
    },
    uploadFile (cobertura, document) {
      this.actualInputFile = { cobertura, document }
      this.$refs.filesInput.click()
    },
    removeFile (cobertura, document) {
      this.files = this.files.map(cob => {
        if (cob.name === cobertura) {
          cob.documents = cob.documents.map(doc => {
            if (doc.name === document) {
              doc.uploaded = false
              doc.filename = ''
              doc.file = null
            }
            return doc
          })
        }
        return cob
      })
    },
    previewFile (evt) {
      // let len = this.filesAttachments.length
      let file = evt.target.files[0]
      evt.target.value = ''
      let ext = file.name.slice((file.name.lastIndexOf('.') - 1 >>> 0) + 2)
      if (!['pdf', 'png', 'jpg', 'jpeg'].includes(ext.toLowerCase())) {
        this.$swal({
          text: 'Tipo de archivo no permitido',
          imageUrl: require('./../assets/img/character/informa.svg'),
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      } else if (file.size > this.sizeMb) {
        this.$swal({
          html: 'El archivo no puede ser mayor a ' + this.sizeText + 'MB. Para más información comunícate con nuestro <a style="text-decoration: underline; text-decoration-color: #0855c4; color: #0855c4; font-family: \'Omnes Medium\';" href="https://wa.me/5115000000" target="_blank">Whatsapp</a>',
          imageUrl: require('./../assets/img/character/informa.svg'),
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      } else {
        const thisFile = this.actualInputFile
        this.files = this.files.map(cobertura => {
          if (cobertura.name === thisFile.cobertura) {
            cobertura.documents.map(document => {
              if (document.name === thisFile.document) {
                document.uploaded = true
                document.filename = file.name
                document.file = file
              }
              return document
            })
          }
          return cobertura
        })
      }
    },
    uploadExtraFile (cobertura) {
      this.actualextraFile = cobertura
      this.$refs.extraFilesInput.click()
    },
    removeExtraFile (cobertura, index) {
      this.files = this.validateSoatVida() ? this.files.map(cob => {
        if (cob.name === cobertura) {
          cob.additional = cob.additional.filter((doc, i) => i !== index)
        }
        return cob
      }) : this.files.filter((doc, i) => i !== index)
    },
    previewExtraFile (evt) {
      // let len = this.filesAttachments.length
      let file = evt.target.files[0]
      evt.target.value = ''
      let ext = file.name.slice((file.name.lastIndexOf('.') - 1 >>> 0) + 2)
      if (!['pdf', 'png', 'jpg', 'jpeg'].includes(ext.toLowerCase())) {
        this.$swal({
          text: 'Tipo de archivo no permitido',
          imageUrl: require('./../assets/img/character/informa.svg'),
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      } else if (file.size > this.sizeMb) {
        this.$swal({
          html: 'El archivo no puede ser mayor a ' + this.sizeText + 'MB. Para más información comunícate con nuestro <a style="text-decoration: underline; text-decoration-color: #0855c4; color: #0855c4; font-family: \'Omnes Medium\';" href="https://wa.me/5115000000" target="_blank">Whatsapp</a>',
          imageUrl: require('./../assets/img/character/informa.svg'),
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      } else if (this.validateSoatVidaProteccion()) {
        this.files = this.files.map(cobertura => {
          if (cobertura.name === this.actualextraFile) {
            cobertura.additional.push({ name: file.name, file: file })
          }
          return cobertura
        })
      } else {
        this.files.push({ name: file.name, file: file })
      }
    },
    getMetodoPago () {
      if (this.form.beneficiarios.length === 0) {
        return 'Pago en ventanilla Interbank'
      }
      return this.form.beneficiarios[0].metodoPago
    },
    countDocuments () {
      if (!this.validateSoatVida()) {
        return this.files.length
      }
      let counter = 0
      for (const cobertura of this.files) {
        counter += cobertura.documents.filter(d => d.uploaded).length + cobertura.additional.length
      }
      return counter
    },
    showDialogBank (evt) {
      if (evt.target.innerText.toString().toLowerCase() === 'help') {
        this.$swal({
          text: 'Solo trabajamos con los bancos que figuran en el listado.',
          showCancelButton: false,
          confirmButtonColor: '#EA0C90',
          confirmButtonText: 'Entendido'
        })
      }
    },
    setTimeoutCallback (delay) {
      const self = this
      setTimeout(() => {
        const result = self.render()
        if (!result) {
          self.execute = (self.execute || 0) + 1
          console.log('Intento fallido: ', self.execute)
          self.setTimeoutCallback(delay)
        }
      }, delay)
    },
    getFiles () {
      if (this.showFiles) {
        this.showFiles = false
        return this.files
      }
      return []
    },
    maskEmail (email) {
      const [username, domain] = email.split('@')
      const maskedUsername = username.slice(0, 2) + '***' + username.slice(-2)
      const maskedEmail = maskedUsername + '@' + domain
      return maskedEmail
    },
    downloadManual () {
      let link = document.createElement('a')
      link.href = 'https://www.interseguro.pe/wp-content/uploads/zona-publica/siniestros/manual-siniestros.pdf'
      link.download = 'Manual de Registro de Siniestros.pdf'
      link.target = '_blank'
      link.click()
    },
    validateEmail (revalidate) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.form.solicitante.correo)) {
        this.showErrorMessage = true
      } else {
        this.showErrorMessage = false
      }
    },
    revalidateEmail (revalidate) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (emailRegex.test(this.form.solicitante.correo)) {
        this.showErrorMessage = false
      }
    },
    validateResponseRequestDate (tipoPoliza) {
      switch (tipoPoliza) {
      case 'Protección tarjeta':
      case 'Protección financiera':
      case 'Renta Hospitalaria':
        this.responseRequestTwoDays = true
        break
      default:
        this.responseRequestTwoDays = false
        break
      }
    },
    showFechaOcurrencia () {
      const coberturas = []
      let show = true
      switch (this.form.tipoPoliza.toLowerCase()) {
      case 'soat':
        coberturas.push('Incapacidad Temporal', 'Gastos médicos')
        break
      case 'protección tarjeta':
        coberturas.push(...siniestro.coberturas['protección tarjeta'].map(c => c.name))
        break
      default:
        coberturas.push('-')
        show = false
      }
      const coberturasValidas = this.coberturasSeleccionadas.filter(cob => coberturas.includes(cob))
      return show && coberturasValidas.length > 0
    },
    showFechasIncapacidad () {
      return this.form.tipoPoliza.toLowerCase() === 'soat' && this.coberturasSeleccionadas.includes('Incapacidad Temporal')
    },
    showMontoSolicitado () {
      const coberturas = []
      let show = true
      switch (this.form.tipoPoliza.toLowerCase()) {
      case 'soat':
        coberturas.push('Gastos médicos')
        break
      case 'protección tarjeta':
        coberturas.push(...siniestro.coberturas['protección tarjeta'].map(c => c.name))
        break
      default:
        coberturas.push('-')
        show = false
      }
      const coberturasValidas = this.coberturasSeleccionadas.filter(cob => coberturas.includes(cob))
      return show && coberturasValidas.length > 0
    },
    showPagador () {
      if (this.form.tipoPoliza.toLowerCase() !== 'soat') {
        return false
      }
      const coberturasValidas = this.coberturasSeleccionadas.filter(cob => cob === 'Gastos médicos')
      return coberturasValidas.length > 0
    },
    closeDatePicker () {
      this.datePicker = false
    },
    addFechasIncapacidad () {
      if (this.form.fechasIncapacidad.length < 4) {
        this.form.fechasIncapacidad.push({fechaInicioIncapacidad: '', fechaFinIncapacidad: ''})
      }
    },
    removeFechasIncapacidad (index) {
      this.form.fechasIncapacidad.splice(index, 1)
    }
  },
  mounted () {
    if (process.env.NODE_ENV === 'development') {
      this.caseId = 'CIS_40528'
      this.form = {
        tipoPoliza: 'Vida',
        asegurado: {
          apellidoPaterno: 'Perensejo',
          apellidoMaterno: 'De Tale',
          nombres: 'Fulanito',
          nroDocumento: '72962622'
        },
        solicitante: {
          apellidoPaterno: 'Perensejo',
          apellidoMaterno: 'De Tale',
          nombres: 'Fulanito',
          nroDocumento: '72962622',
          correo: 'milagros.palma@interseguro.com.pe',
          celular: '999888777'
        },
        beneficiarios: [],
        narracion: '',
        fechaOcurrencia: '',
        fechasIncapacidad: [
          {
            fechaInicioIncapacidad: '',
            fechaFinIncapacidad: ''
          }
        ]
      }
      this.beneficiarioCuenta = {
        metodoPago: 'Transferencia bancaria',
        nroCuenta: '00112516546216452',
        titular: 'Fulanito Perensejo',
        nroDocumento: '003232651',
        banco: 'Interbank',
        moneda: 'Soles',
        tipoCuenta: 'Ahorro'
      }
      this.captchaValid = true
    } else {
      this.setTimeoutCallback(1000)
    }
  }
}
</script>

<style>
  @import url('../assets/css/general.css');
  @import url('../assets/css/sinisters.css');

  .conditions-policy, .conditions-policy a {
    font-style: normal;
    font-weight: 400;
    font-size: 11px;
    line-height: 12px;
  }

  .conditions-policy a {
    text-decoration: underline;
    text-decoration-color: #0855c4;
    color: #0855c4;
  }

  .conditions-policy::marker {
    color: #0855c4;
  }

  .v-tooltip.v-tooltip--bottom .v-tooltip__content {
    top: auto !important;
  }

  i.v-icon.material-icons.theme--light.accent--text {
    color: #0855c4;
  }

  .v-input__icon--prepend-inner .theme--light.v-icon {
    color: rgb(0 0 0 / 33%);
    font-size: 20px;
  }

  .v-text-field--outline .v-input__control .v-input__slot {
    border: 1px solid rgba(0,0,0,0.54) !important;
  }

  .v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) .v-input__control .v-input__slot:hover {
    border: 1px solid rgba(0,0,0,0.65) !important;
  }

  .v-textarea.v-text-field--box .v-text-field__prefix, .v-textarea.v-text-field--enclosed .v-text-field__prefix, .v-textarea.v-text-field--box textarea, .v-textarea.v-text-field--enclosed textarea {
    margin-top: 24px;
    height: 76px;
  }

  .v-textarea.v-text-field--box.without-placeholder .v-text-field__prefix, .v-textarea.v-text-field--enclosed .v-text-field__prefix, .v-textarea.v-text-field--box textarea, .v-textarea.v-text-field--enclosed textarea {
    margin-top: 0px;
    height: 100px;
  }

  .v-input.select-box.v-text-field.v-input--is-disabled .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
    display: none;
  }

  .v-input.select-box.v-text-field .v-input__control .v-input__slot .v-menu > .v-menu__content.theme--light.menuable__content__active,
.v-input.select-box.v-text-field .v-input__control .v-input__slot .v-menu > .v-menu__content.siniestro-select-menu.menuable__content__active {
  top: 0 !important;
  left: 0 !important;
  z-index: 9999 !important;
}

.siniestro-select-menu {
  z-index: 9999 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/LandingSiniestros.vue